import { Instagram, Mail, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/10 bg-[#050505]" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12">
          <div>
            <h2 className="font-anton uppercase text-6xl md:text-8xl leading-[0.85] text-white">
              TMB<span className="text-[#5cc6ff]">.</span>
            </h2>
            <p className="font-manrope text-white/40 mt-4 max-w-xs">
              Raw Action | TMB Fotografia
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <a
              href="https://instagram.com/tmbfotografia"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-3 font-outfit uppercase tracking-[0.15em] text-sm text-white/70 hover:text-[#5cc6ff] transition-colors group"
            >
              <Instagram size={18} strokeWidth={1.5} />
              @tmbfotografia
              <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
            <a
              href="mailto:tmbfoto.sports@gmail.com"
              data-testid="footer-email"
              className="flex items-center gap-3 font-outfit tracking-[0.15em] text-sm text-white/70 hover:text-[#5cc6ff] transition-colors lowercase"
            >
              <Mail size={18} strokeWidth={1.5} />
              tmbfoto.sports@gmail.com
            </a>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-20 pt-8 border-t border-white/10">
          <span className="font-outfit text-xs uppercase tracking-[0.2em] text-white/30">
            © {year} TMB Fotografia — All rights reserved
          </span>
          <span className="font-outfit text-xs uppercase tracking-[0.2em] text-white/30">
            Raw Action · Untamed Kinetics
          </span>
        </div>
      </div>
    </footer>
  );
};
